import React from "react";
import { useNavigate } from "react-router-dom";
import { useCompare } from "../../../hooks/useCompare";
import { ROUTES } from "../../../data";
import { API_BASE_URL } from "../../Constant";
import { useTranslation } from "react-i18next";
import "./CompareBar.scss";

/**
 * Floating bar shown at the bottom of the screen when the user has
 * one or more products in their compare list.
 */
const CompareBar = () => {
  const { t } = useTranslation();
  const { compareList, removeFromCompare, clearCompare } = useCompare();
  const navigate = useNavigate();

  if (!compareList.length) return null;

  return (
    <div className="compare-floating-bar">
      <div className="compare-floating-bar__inner">
        <span className="compare-floating-bar__label">
          {t('compare.comparingCount', { count: compareList.length })}
        </span>

        <div className="compare-floating-bar__thumbs">
          {compareList.map((slug) => (
            <div key={slug} className="compare-floating-bar__thumb">
              <span className="compare-floating-bar__slug" title={slug}>
                {slug.length > 14 ? slug.substring(0, 14) + "..." : slug}
              </span>
              <button
                className="compare-floating-bar__remove"
                onClick={() => removeFromCompare(slug)}
                title="Remove"
              >
                &times;
              </button>
            </div>
          ))}
        </div>

        <div className="compare-floating-bar__actions">
          <button
            className="compare-floating-bar__btn compare-floating-bar__btn--compare"
            onClick={() => navigate(ROUTES.COMPARE)}
            disabled={compareList.length < 2}
          >
            {t('compare.compareNow')}
          </button>
          <button
            className="compare-floating-bar__btn compare-floating-bar__btn--clear"
            onClick={clearCompare}
          >
            {t('compare.clear')}
          </button>
        </div>
      </div>
    </div>
  );
};

export { CompareBar };
